import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './SeasonAdvancementOverlay.css';

interface SeasonAdvancementOverlayProps {
    isVisible: boolean;
}

const STAGES = [
    'Processing player contracts...',
    'Updating player development...',
    'Calculating AI team transfers...',
    'Processing free agent offers...',
    'Updating league standings...',
    'Generating youth academy intakes...',
    'Processing facility upgrades...',
    'Finalizing season data...',
];

export const SeasonAdvancementOverlay: React.FC<SeasonAdvancementOverlayProps> = ({ isVisible }) => {
    const [currentStageIndex, setCurrentStageIndex] = useState(0);

    useEffect(() => {
        if (!isVisible) {
            setCurrentStageIndex(0);
            return;
        }

        // Cycle through stages with timing
        const intervals: NodeJS.Timeout[] = [];

        STAGES.forEach((_, index) => {
            const timeout = setTimeout(() => {
                setCurrentStageIndex(index + 1);
            }, (index + 1) * 600); // Each stage appears every 600ms
            intervals.push(timeout as any);
        });

        return () => {
            intervals.forEach(interval => clearTimeout(interval));
        };
    }, [isVisible]);

    if (!isVisible) {
        return null;
    }

    const progressPercentage = ((currentStageIndex) / STAGES.length) * 100;
    const currentStage = currentStageIndex < STAGES.length ? STAGES[currentStageIndex] : 'Complete!';

    return (
        <div className="season-advancement-overlay">
            <div className="season-advancement-container">
                <div className="season-advancement-spinner">
                    <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />
                </div>

                <h2 className="season-advancement-title">Advancing to Next Season</h2>

                <div className="season-advancement-stage">
                    <p className="stage-text">{currentStage}</p>
                </div>

                <div className="season-advancement-progress">
                    <div className="progress-bar">
                        <div
                            className="progress-fill"
                            style={{ width: `${progressPercentage}%` }}
                        ></div>
                    </div>
                    <p className="progress-text">
                        {currentStageIndex} of {STAGES.length}
                    </p>
                </div>

                <p className="season-advancement-message">
                    Processing complex calculations... This may take a moment.
                </p>
            </div>
        </div>
    );
};
